import { CARD_SHAPES } from './constants';

export const WHOT_DESIGN = {
  INK_RED: '#9B0F0F',
  CARD_BG: '#F3F4F6',

  SHAPES: {
    [CARD_SHAPES.CIRCLE]: {
      name: 'CIRCLE',
      kind: 'circle',
    },
    [CARD_SHAPES.SQUARE]: {
      name: 'SQUARE',
      kind: 'square',
    },
    [CARD_SHAPES.STAR]: {
      name: 'STAR',
      kind: 'star',
    },
    [CARD_SHAPES.TRIANGLE]: {
      name: 'TRIANGLE',
      kind: 'triangle',
    },
    [CARD_SHAPES.CROSS]: {
      name: 'CROSS',
      kind: 'cross',
    },
  },

  getCardLayout: (number, shape) => {
    const shapeInfo = WHOT_DESIGN.SHAPES[shape] || WHOT_DESIGN.SHAPES[CARD_SHAPES.STAR];
    const n = Number(number);

    const specialLabel = null;

    if (n === 20) {
      return {
        number: '20',
        center: { type: 'whot-text', symbol: 'w', text: 'Whot' },
        corners: { type: 'whot-w', symbol: 'w' },
        color: WHOT_DESIGN.INK_RED,
        isWhot: true,
        label: 'WHOT',
        centerNumber: null,
      };
    }

    return {
      number: String(n),
      center: { type: 'shape', kind: shapeInfo.kind },
      corners: { type: 'shape', kind: shapeInfo.kind },
      color: WHOT_DESIGN.INK_RED,
      isWhot: false,
      label: specialLabel,
      centerNumber: shape === CARD_SHAPES.STAR ? String(n * 2) : null,
    };
  },
};

export function getShapeName(shape) {
  const shapeMap = {
    [CARD_SHAPES.CIRCLE]: 'CIRCLE',
    [CARD_SHAPES.SQUARE]: 'SQUARE',
    [CARD_SHAPES.STAR]: 'STAR',
    [CARD_SHAPES.TRIANGLE]: 'TRIANGLE',
    [CARD_SHAPES.CROSS]: 'CROSS',
  };
  return shapeMap[shape] || String(shape || '').toUpperCase();
}
